/**
 * Allows the browser to finish the current event loop and resolve this promise on the
 * next iteration.
 */
export function nextTick(): Promise<void> {
   return new Promise((resolve) => setTimeout(resolve, 0));
}
